// removed by extract-text-webpack-plugin
module.exports = {"container":"Calendar__container___uhJt4"};